import * as React from 'react';
import DC from '../../../common/DataConnector';
import { i18n } from '../../../lang/i18n';
import BackArrow from '../../../components/BackArrowComponent/BackArrow';
import { renderIcon } from '../../../common/Medias';
import ScrollToTop from '../../../components/ScrollToTop';
import { useAppSelector } from '../../../store/hooks';


export default function LoyaltyScreen()
{
    const userData = useAppSelector((state) => state.userData)
    const [loyalty, setLoyalty] = React.useState<any>({ history: [], customerLevel: 3 })

    React.useEffect(() =>
    {
        (async function ()
        {
            let content = await DC.Get('/customer/loyalty', {});
            if (content.wasOk) {
                setLoyalty(content.data);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function renderLoyaltyIcon()
    {
        switch (loyalty.customerLevel) {
            case 1: // gold
                return renderIcon('icon-loyalty-gold')
            case 2:
                return renderIcon('icon-loyalty-gold')
            default:
                return renderIcon('icon-loyalty-gold')
        }
    }
    function renderLevelText()
    {
        switch (loyalty.customerLevel) {
            case 1:
                return i18n.CustomerLoyalty.YouAreLevel1;
            case 2:
                return i18n.CustomerLoyalty.YouAreLevel2;
            default:
                return i18n.CustomerLoyalty.YouAreLevel3;
        }
    }

    return (
        <div className="users loyalty">
            <ScrollToTop />
            <div className='text-center'>{renderIcon('icon-loyalty')}</div>
            <div className="main-subtitle">
                <h3>{i18n.CustomerLoyalty.ThankYouForYourLoyalty}</h3>
            </div>
            <div className='loyalty-box'>
                <div style={{ flex: 0.5 }}></div>
                <div>
                    <div className='box'>
                        {renderLoyaltyIcon()}
                    </div>
                </div>
                <div style={{ flex: 0.5 }}></div>
                <div>
                    <div className='box'>
                        <div className='loyalty-ritmitos w-100'>{loyalty.ritmitosAvailable}⚡</div>
                        {userData.loyalty.ritmitosInOrders > 0 && <div>{userData.loyalty.ritmitosInOrders}⚡ {i18n.CustomerLoyalty.OnOngoingOrders}</div>}
                        {loyalty.ritmitosToExpire > 0 && <small>{loyalty.ritmitosToExpire} {i18n.CustomerLoyalty.ExpireIn15Days}</small>}
                    </div>
                </div>
                <div style={{ flex: 0.5 }}></div>
            </div>
            <div className='loyalty-box text-center'>
                <div></div>
                <div>
                    <label>{renderLevelText()}</label>
                </div>
                <div></div>
                <div>
                    <div>{i18n.CustomerLoyalty.AccumulatedRitmitos}</div>
                </div>
                <div></div>
            </div>
            <div className='container mt-4'>
                <div className='row'>
                    <div className='col-12'>{i18n.CustomerLoyalty.AccumulateRitmitosOnEachPurchase}</div>
                    <div className='col-12'>{i18n.CustomerLoyalty.RitmitosCanBeUseIn6Months}</div>
                </div>
            </div>
            <BackArrow path="/user" />
        </div>
    );
}